// loginform.ts ↔ game/loginform.cpp — the MULTIPLAYER LOGIN form's shared
// constants (kidfLogin, forms.ini 1074) + the account-service URLs. The canvas
// LoginForm class was removed (canvas-removal R1); the DOM lobby drives login
// now (dom/lobby-controller.ts), reusing kszRegisterUrl/kszForgotAccountUrl.

// game/res.h:70 + :236-241 + :265-287
export const kidfLogin = 1074;
export const kidcAnonymous = 1200;
export const kidcLogin = 1201;
export const kidcRegister = 1202;
export const kidcForgotAccount = 1203;
export const kidcPlayerName = 1005;
export const kidcPlayerNamePanel = 1007;
export const kidcPassword = 1101;
export const kidcPasswordLabel = 1107;
export const kidcPasswordPanel = 1108;
export const kidcForums = 1502; // the "Enter Player Name and Password:" label slot

// game/serviceurls.cpp:21-22 (the production block)
export const kszRegisterUrl = 'https://api.warfareincorporated.com/accounts/register';
export const kszForgotAccountUrl = 'https://api.warfareincorporated.com/accounts/forgotaccount';
